const Shimmer = () => {
  return (
    <div className="m-2 p-4 flex flex-wrap">
      <div className="m-4 p-4 w-[225px] h-[415px] rounded-lg bg-gray-100"></div>
      <div className="m-4 p-4 w-[225px] h-[415px] rounded-lg bg-gray-100"></div>
      <div className="m-4 p-4 w-[225px] h-[415px] rounded-lg bg-gray-100"></div>
      <div className="m-4 p-4 w-[225px] h-[415px] rounded-lg bg-gray-100"></div>
      <div className="m-4 p-4 w-[225px] h-[415px] rounded-lg bg-gray-100"></div>
      <div className="m-4 p-4 w-[225px] h-[415px] rounded-lg bg-gray-100"></div>
      <div className="m-4 p-4 w-[225px] h-[415px] rounded-lg bg-gray-100"></div>
      <div className="m-4 p-4 w-[225px] h-[415px] rounded-lg bg-gray-100"></div>
      <div className="m-4 p-4 w-[225px] h-[415px] rounded-lg bg-gray-100"></div>
      <div className="m-4 p-4 w-[225px] h-[415px] rounded-lg bg-gray-100"></div>
      <div className="m-4 p-4 w-[225px] h-[415px] rounded-lg bg-gray-100"></div>
      <div className="m-4 p-4 w-[225px] h-[415px] rounded-lg bg-gray-100"></div>
      <div className="m-4 p-4 w-[225px] h-[415px] rounded-lg bg-gray-100"></div>
      <div className="m-4 p-4 w-[225px] h-[415px] rounded-lg bg-gray-100"></div>
      <div className="m-4 p-4 w-[225px] h-[415px] rounded-lg bg-gray-100"></div>
    </div>
  );
};

export default Shimmer;
